import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../controls/button';

const BotButtonsControl = ({ buttons, enabled, onSubmit }) => {
    const onClick = ({ id, text }) => {
        onSubmit({ id, text });
    };

    return (
        <div className="botButtons">
            {buttons
                ? buttons.map((button, i) => (
                    <Button
                        key={i}
                        className={
                            'white ' +
                              (button.text.toUpperCase() === 'TAK' ||
                              button.text.toUpperCase() === 'NIE'
                                  ? 'binary'
                                  : '')
                        }
                        disabled={!enabled}
                        id={button.id}
                        text={button.text}
                        onClick={() =>
                            onClick({
                                id: button.id,
                                text: button.text
                            })
                        }
                    />
                ))
                : null}
        </div>
    );
};

BotButtonsControl.defaultProps = {
    buttons: [],
    enabled: false
};

BotButtonsControl.propTypes = {
    buttons: PropTypes.array,
    enabled: PropTypes.bool
};

export default BotButtonsControl;
